var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout",class:{
    'checkout--with-aside': _vm.$slots.aside,
  }},[_c('div',{staticClass:"checkout__main"},[_vm._t("main")],2),_vm._v(" "),(_vm.$slots.aside)?_c('div',{staticClass:"checkout__aside"},[_vm._t("aside")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }